/** Описания на плановете. Имената (Starter, Pro, Elite) не се превеждат. */
export default {
  period: "еднократно",
  creditsIncluded_one: "{{count}} точка",
  creditsIncluded_other: "{{count}} точки",
  /** Предимствата без обем, които получава персонална сума на всяко ниво. */
  benefits: {
    starter: ["Лиценз за търговска употреба", "Поддръжка по имейл"],
    pro: ["Лиценз за търговска употреба", "Приоритетна поддръжка по имейл"],
    elite: ["Лиценз за търговска употреба", "Приоритетна поддръжка по имейл и телефон"],
    studio: ["Всичко от Elite", "Личен акаунт мениджър", "Персонализирано фактуриране"],
  },
  starter: {
    tagline: "За творци, които тепърва започват с AI визуализации.",
    cta: "Започнете със Starter",
    features: [
      "20 точки — до 20 изображения или 10 видеоклипа",
      "Изображения до 1024 × 1024 px",
      "Видеоклипове до Full HD (1080p)",
      "Лиценз за търговска употреба",
      "Поддръжка по имейл",
    ],
  },
  pro: {
    tagline: "За професионалисти, които търсят скорост и прецизност.",
    cta: "Изберете Pro",
    features: [
      "100 точки — до 100 изображения или 50 видеоклипа",
      "Изображения до 1024 × 1024 px",
      "Видеоклипове до Full HD (1080p)",
      "Лиценз за търговска употреба",
      "Приоритетна поддръжка по имейл",
    ],
  },
  elite: {
    tagline: "За студия и екипи с голям обем работа.",
    cta: "Разраснете се с Elite",
    features: [
      "300 точки — до 300 изображения или 150 видеоклипа",
      "Изображения до 1024 × 1024 px",
      "Видеоклипове до Full HD (1080p)",
      "Лиценз за търговска употреба",
      "Приоритетна поддръжка по имейл и телефон",
    ],
  },
};
